/** SW нужен для установки PWA и Web Push; в dev не регистрируем, чтобы не мешал HMR. */
export function registerServiceWorker() {
    if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch((err) => console.warn('[pwa] SW не зарегистрирован', err));
    });
}
